import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sv-magic-string',
  templateUrl: './datatable-component.html',
  styles: []
})
export class DataTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    console.log('testing datatable component library');
  }
}
